const NewPaymentModalSkeleton = () => (
  <div className="animate-pulse md:px-[40px] w-3/4 mx-auto px-3">
    <div className="h-[45px]  mt-3 bg-gray-200 mb-5" />
    <div className="h-[85px] w-full mx-auto mt-3 bg-gray-200 mb-4" />
    <div className="h-[250px] w-full mx-auto mt-3 bg-gray-200 px-4 mb-4" />
    <div className="h-[45px]  w-full mx-auto mt-3 bg-gray-200" />
  </div>
);

export default NewPaymentModalSkeleton;
